import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 35px;

  &.custom-size img,
  &.custom-size-bottom img{
      width: 300px;
  };

  &.custom-size span { 
    font-size: 14px;
    margin-bottom: 10px;
  };

  &.custom-size-bottom span {
    font-size: 14px;
    margin-bottom: 15px;
  };
`;

export const Image = styled.img`
  width: 590px;
  @media screen and (max-width: 960px) {
    width: 95%;
  };
`;

export const Text = styled.span`
  text-align: center;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #A6A6A6;
  font-size: 20px;
  font-family: Roboto, sans-serif;
  font-weight: 500;
`;
